export const MomentTypes = {
  USER: 'USER',
  PORTAL: 'PORTAL',
  MOMENT: 'MOMENT'
};